import { chineseNumeralFormatter } from '@/src/libs/number-helper';
import { ListingDetail } from '@/swagger';
import { getLayout } from '@/src/helper/listing';

export const getOgDescription = (detailData: ListingDetail | ReplaceValueType<ListingDetail, Date, number>): string => {
  const { display_address, price } = detailData;
  const subtitle = getLayout(detailData, detailData.floor_plan_type);
  return `${display_address} ${subtitle}${chineseNumeralFormatter(price || 0, detailData.country!)}`;
};
